import { render, staticRenderFns } from "./BackTone.vue?vue&type=template&id=7d60906f"
import script from "./BackTone.vue?vue&type=script&lang=js"
export * from "./BackTone.vue?vue&type=script&lang=js"
import style0 from "./BackTone.vue?vue&type=style&index=0&id=7d60906f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports